const mapEl = document.getElementById('park-map')

const loadGoogleMapsApi = () => {
  if (document.getElementById('google-maps-api-js')) {
    document.getElementById('google-maps-api-js').remove()
  }

  const tag = document.createElement('script')
  tag.src = `https://maps.googleapis.com/maps/api/js?key=${mapEl.dataset.key}&callback=initMap`
  tag.id = 'google-maps-api-js'

  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

if (mapEl) {
  loadGoogleMapsApi()
}

window.initMap = () => {
  const google = window.google
  const mapEl = document.getElementById('park-map')

  if (!mapEl) {
    return
  }

  const infoWindow = document.querySelector('.map-info-window')
  const data = JSON.parse(mapEl.dataset.json)

  const mapOptions = {
    center: new google.maps.LatLng(data.lat, data.lng),
    zoom: 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    scrollwheel: false,
    gestureHandling: 'none',
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
    ],
  }

  const map = new google.maps.Map(mapEl, mapOptions)
  const bounds = new google.maps.LatLngBounds()

  google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
    const mapMarker = {
      url: "data:image/svg+xml,%3Csvg viewBox='0 0 63 92' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.037.5c16.83 0 30.538 13.706 30.538 30.537 0 12.11-5.034 19.75-11.386 29.392-1.5 2.276-3.072 4.663-4.669 7.247L31.037 90.944 16.555 67.678v-.001c-1.598-2.584-3.17-4.971-4.67-7.247C5.534 50.787.5 43.147.5 31.037.5 14.207 14.206.5 31.037.5Zm17.607 29.315c0-9.558-7.795-17.607-17.607-17.607-9.811 0-17.607 8.049-17.607 17.607 0 9.807 7.8 17.607 17.607 17.607 9.807 0 17.607-7.8 17.607-17.607Z' fill='url(%23a)' stroke='%23fff'/%3E%3Cdefs%3E%3ClinearGradient id='a' x1='31.035' y1='91.895' x2='31.035' y2='0' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2300859E'/%3E%3Cstop offset='.14' stop-color='%23008D8D'/%3E%3Cstop offset='.53' stop-color='%2300A35F'/%3E%3Cstop offset='.72' stop-color='%2300AC4E'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E",
      scaledSize: new google.maps.Size(50, 74),
    }
    const marker = new google.maps.Marker({
      map: map,
      title: data.title,
      position: new google.maps.LatLng(data.lat, data.lng),
      panposition: new google.maps.LatLng(data.lat, data.lng),
      icon: mapMarker,
    })

    google.maps.event.addListener(marker, 'click', () => {
      window.open(data.url, '_blank')
    })

    google.maps.event.addListener(marker, 'mouseover', function () {
      this.setAnimation(google.maps.Animation.BOUNCE)
    })

    google.maps.event.addListener(marker, 'mouseout', function () {
      this.setAnimation(null)
    })

    bounds.extend(marker.getPosition())

    const infoWindowHeight = parseInt(infoWindow.offsetHeight)

    if (window.matchMedia('(min-width: 768px)').matches) {
      map.panBy(-60, -40)
    } else {
      map.panBy(0, infoWindowHeight * -1.1)
    }
  })
}
